"use client"

import { useEffect } from "react"

import { notify } from "@/lib/observability/bugsnag"

// Backstop for failures in the root layout itself — above the in-app
// ErrorBoundary — so it must render its own <html>/<body>. Next only mounts this
// in production builds. Styles are inline because the root layout (and its
// globals.css import) is replaced while this is on screen.
export default function GlobalError({
  error,
  unstable_retry,
}: {
  error: Error & { digest?: string }
  unstable_retry: () => void
}) {
  useEffect(() => {
    notify(error)
  }, [error])

  return (
    <html lang="en">
      <body style={{ margin: 0 }}>
        <div
          style={{
            minHeight: "100svh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 20,
            padding: 32,
            textAlign: "center",
            fontFamily:
              "system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
            color: "#1c1917",
            background: "#faf7f5",
          }}
        >
          <div>
            <h1 style={{ fontSize: 20, fontWeight: 600, margin: 0 }}>
              Something went wrong
            </h1>
            <p style={{ marginTop: 8, fontSize: 14, color: "#78716c" }}>
              The app hit an unexpected error. Please try again.
            </p>
          </div>
          <button
            type="button"
            onClick={() => unstable_retry()}
            style={{
              border: "none",
              borderRadius: 12,
              background: "#5d0a20",
              color: "#fff",
              padding: "10px 20px",
              fontSize: 14,
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  )
}
